
import useCommonApi from "../../api/useCommonApi";
import { ClaveProductoActionTypes, ClaveProductoState, LOAD_CLAVESPRODUCTO_SUCCESS } from "../types/claveProductoActionTypes";



const apiSource = useCommonApi();

function loadClavesProductoSuccess(clavesProducto: ClaveProductoState[]): ClaveProductoActionTypes {
    return {
        type: LOAD_CLAVESPRODUCTO_SUCCESS,
        clavesProducto
    }
}

export function loadClavesProducto(clienteId:number) {
    return function (dispatch) {
        return apiSource.obtener<ClaveProductoState[]>("solicitud-servicio/get-catalogo-clave-producto/"+clienteId)
            .then((clavesProducto: ClaveProductoState[]) => {
                dispatch(loadClavesProductoSuccess(clavesProducto))
            })
            .catch(error => {
              //  throw error;
            })
    }
}
